import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Agenzia Marra. Comunichiamo il vino.';
  currentYear = new Date().getFullYear();
}
